module.exports = __webpack_public_path__ + "media/images/logos/logo-services-white-f399fd7a1bff8c10f2c0f7c3b692ea96.svg";